(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1133],{

/***/ 1133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HomeownersInsurance; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59005);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function HomeownersInsurance() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: ` lg:mt-28 mt-16 md:p-20 py-10 px-5 ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().mainSection)}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: " mx-auto text-[#fff] sm:text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "font-bold lg:text-3xl text-xl lg:leading-[45px] ",
                    children: "Differentiating Home Warranties From Homeowners' Insurance"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-7 font-light lg:text-lg text-base lg:leading-8 ",
                    children: "While homeowners' insurance focuses on protecting your home's structure and property, a home warranty provides additional coverage for your appliances and systems. It serves as a complementary service to homeowners' insurance, addressing a different aspect of your home's protection. It's important to note that manufacturer warranties may already cover some of your home systems if you've recently purchased a new home."
                })
            ]
        })
    });
}


/***/ }),

/***/ 59005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"style_mainSection__T7VnM"};

/***/ })

}]);